import React from 'react';
import cx from 'classnames';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import { TPAComponentsProvider } from '@wix/wix-ui-tpa/cssVars';
import s from './ProductPageApp.scss';
import { StateProvider } from '../stores';
import { SPECS } from '../../../../consts';

import ProductPageBody from '../Components/ProductPageBody/ProductPageBody';

export enum ProductPageAppDataHook {
  root = 'ProductPageAppDataHook.root',
  main = 'ProductPageAppDataHook.main',
}
function ProductPageApp() {
  const { isRTL } = useEnvironment();
  const { experiments } = useExperiments();
  const isRtlContextEnabled = experiments.enabled(
    SPECS.EnableGiftCardWidgetRtlContext,
  );
  const classNames = cx(s.main, s.viewer_classic);

  const page = (
    <main
      className={classNames}
      data-hook={ProductPageAppDataHook.main}
      dir={isRtlContextEnabled ? (isRTL ? 'rtl' : 'ltr') : undefined}
    >
      <StateProvider>
        <ProductPageBody />
      </StateProvider>
    </main>
  );

  return (
    <div
      className={cx(s.container, s.queryContainer)}
      data-hook={ProductPageAppDataHook.root}
    >
      {isRtlContextEnabled ? (
        <TPAComponentsProvider value={{ rtl: isRTL }}>
          {page}
        </TPAComponentsProvider>
      ) : (
        page
      )}
    </div>
  );
}

export default ProductPageApp;
